import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './CommdocList.html?raw';
import on from 'dojo/on';
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import { VAM2types, VAMclassNames } from "../_loadingHelpers/VAMv2Types";
import SelectBox from '../../moreCore/UI/SelectBox/SelectBox';
import EntityStore from '../../moreCore/Tools/EntityStore';
import PageStack from '../../moreCore/UI/Tabbing/PageStack';
import "../../moreCore/UI/Tabbing/PageStack";
import CommdocView from './CommdocView';


interface PagedCommdocData {
    name: string,
    label: string,
    selected?: boolean,
    entitylist: Array<VAM2types.Commdoc>,
    layouts?: Array<StaticTable.Layout>
}

interface RegisteredPageSection {
    tablewidget: MdsLax<InstanceType<typeof StaticTable>>,
    entitylist: Array<VAM2types.Commdoc>,
    store: MdsLax<InstanceType<typeof EntityStore<VAM2types.Commdoc>>>
}
class CommdocList extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private parentEntityClassname: string;
    private parentEntityId: string;
    private tableContainer: HTMLElement;

    private pageStack: MdsLax<InstanceType<typeof PageStack>>;

    private registeredTables: Array<RegisteredPageSection>;

    //private table: StaticTable;

    //private store: EntityStore<VAM2types.Commdoc>;

    //private entitylist: Array<any>;

    setup(parentEntityClassname: VAMclassNames,
        parentEntityId: string,
        tableLayout?: StaticTable.Layout) {
        this.parentEntityClassname = parentEntityClassname;
        this.parentEntityId = parentEntityId;

        if (tableLayout) this.tableLayout = tableLayout;

        this._loadCommdocList();
    }

    private tableLayout: StaticTable.Layout = {
        label: "",
        name: "default",
        labelProperty: "doc_no",
        rows: [{
            "attributes": ["$ClassPrintname", "doc_no", "ref_doc_status.description"],
            colNamesInternal: ["$ClassPrintname", "doc_no", "ref_doc_status.description", /*"files", "Download"*/],
            "colspans": [1, 1, 1, 1, 1, 1],
            "headings": [(this as any).translate("General_Label_VtCommdocClass"), (this as any).translate("General_Label_DocNo"), (this as any).translate("General_Label_Status"), (this as any).translate("General_Label_DokFiles"), (this as any).translate("General_Label_Download"), (this as any).translate("General_Label_Actions")],
            widths: ["", "", "", null, "11ch", "14ch"],
            alignmentsHeading: [null, null, null, null, "center", "center"],
            alignmentsRow: [null, null, null, null, "center", "center"]
        }]
    }

    private table_formatterFunction(cell: StaticTable.StaticTableCell<VAM2types.Commdoc>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let rowIndex = cell.tableRow.rowGroup.rowIndex;

        let icon: HTMLElement;
        if (!cell.tableRow["fileSelect"]) cell.tableRow["fileSelect"] = new SelectBox();

        this.UiModder.domStyle.set(cell.tableCellNode, "vertical-align", "middle");

        switch (colName) {
            case "Download":

                icon = this.createFontawesomeIcon("fas fa-download hoverTxtPrimary secondaryText", "", node);
                this.UiModder.domAttr.set(icon, "title", this.translations["CommdocList_ButtonTitle_Download"]);
                on(icon, "click", lang.hitch(this, this._downloadFile, cell.tableRow["fileSelect"]));
                if (entity.vt_files.length < 1) this.disableNode(icon);

                return true;
                break;

            case "files":

                let rowFileSelect: MdsLax<InstanceType<typeof SelectBox>> = cell.tableRow["fileSelect"];

                rowFileSelect.placeAt(node);

                if (entity.vt_files.length > 0) {

                    entity.vt_files.forEach(file => {

                        rowFileSelect.addOption(file.ID, file.filename);
                    });
                } else {

                    rowFileSelect.addOption(null, this.translations["CommdocList_FileSelect_NoFiles"]);
                    this.disableNode(rowFileSelect.domNode);
                }
                rowFileSelect.constructOptions();
                return true;
                break;
        }

        return false;
    }

    private _downloadFile(fileSelect: MdsLax<InstanceType<typeof SelectBox>>): void {

        let fileId = fileSelect.getValue();
        console.log("FILE", fileId);

        if (!fileId) return;

        window.open(window.appRoot + `EvBookingEditor/DownloadExistingFile?downloadKey=${fileId}`);
    }

    private _onRowClick(row: StaticTable.StaticTableRow<DocumentEntity>) {
        let entity = row.rowGroup.entity;

        let view = new CommdocView();
        view.setup(entity.ID, entity.$Displayname);
        view.on("saved", lang.hitch(this, this.reload));
    }



    private _onLoadDataResponse(pagedData: Array<PagedCommdocData>) {

        let completeList = [];
        for (let data of pagedData) {
            this.addSection(data);

            completeList.push(...data.entitylist);
        }

        this.emit("loaded", completeList.length > 0);

        this.StandbyStop();

    }

    addSection(data: PagedCommdocData) {

        if (!data) return;

        if (!data.name) data.name = "_default";


        let store = new EntityStore<VAM2types.Commdoc>()
        let table = new StaticTable();


        if (this.pageStack.hasPage(data.name)) {
            this.pageStack.setPageContent(data.name, table.domNode);
        } else {

            this.pageStack.addPage(table, {
                label: data.label,
                name: data.name
            });
        }

        if (data.selected == true) this.pageStack.activatePageByName(data.name);

        let newPage: RegisteredPageSection = {
            entitylist: data.entitylist,
            store: store,
            tablewidget: table
        };

        this.registeredTables.push(newPage);


        store.setup(data.entitylist);

        table.setFormatter(lang.hitch(this, this.table_formatterFunction));

        if (data.layouts?.length) {
            for (let layout of data.layouts) {
                table.addLayout(layout);
            }
        } else {
            table.setLayout(this.tableLayout);
        }


        table.setRowClick(lang.hitch(this, this._onRowClick));

        table.setupFromStore(store, "doc_no");




    }

    reload(): void {
        this._loadCommdocList();
    }

    private _loadCommdocList(): void {

        this.StandbyStart();
        let requestUrl = window.appRoot + "ProjectWizard/GetCommdocList";

        let data = {
            getPagedResults: true
        };

        data[this.parentEntityClassname] = this.parentEntityId;

        this.RequestManager.callfunction(
            "Webtool_API_CommDoc__GetListJSON",
            data,
            lang.hitch(this, this._onLoadDataResponse),
            lang.hitch(this, this._showErrorMessage),
            false // sync
        );
    }

    private _showErrorMessage(err: any) {
        this.StandbyStop();
        alert(err.Message);
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.registeredTables = [];

        this.RequestManager.handleAs = "jsonWithDate";
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(CommdocList);
